export const useIsCatalogCourse = () => {
  return window.location.href.includes('/catalog')
}
